import script from "./SSOView.vue?vue&type=script&setup=true&lang=js"
export * from "./SSOView.vue?vue&type=script&setup=true&lang=js"

import "./SSOView.vue?vue&type=style&index=0&id=de4b8118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de4b8118"]])

export default __exports__